module.exports = __webpack_public_path__ + "img/phoenix_kedel_5.5478996f.png";